"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.findPriceHistoryByFiatSymbol = exports.findByFiatSymbol = void 0;
const fiat_market_providers_1 = require("./fiat-market-providers");
const findByFiatSymbol = async ({ symbol }) => {
    let result = null;
    // Loop through market providers and look for fiat market data. Once found, exit loop.
    for (let i = 0; i < fiat_market_providers_1.FiatMarketProviders.length && !result; i++) {
        try {
            result = await fiat_market_providers_1.FiatMarketProviders[i].findByFiatSymbol({ symbol });
        }
        catch (e) {
            // Swallow error, not every fiat will be with every provider.
        }
    }
    if (!result)
        return null;
    return result;
};
exports.findByFiatSymbol = findByFiatSymbol;
const findPriceHistoryByFiatSymbol = async ({ symbol, timeframe, }) => {
    let result = null;
    // Loop through market providers and look for fiat price history data. Once found, exit loop.
    for (let i = 0; i < fiat_market_providers_1.FiatMarketProviders.length && !(result === null || result === void 0 ? void 0 : result.length); i++) {
        try {
            result = await fiat_market_providers_1.FiatMarketProviders[i].findPriceHistoryByFiatSymbol({ symbol, timeframe });
        }
        catch (e) {
            // Swallow error, not every fiat will be with every provider.
        }
    }
    if (!result)
        return [];
    return result;
};
exports.findPriceHistoryByFiatSymbol = findPriceHistoryByFiatSymbol;
